export default () => ({
    organizaciones: []
})